import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import whatsapp from "../assets/images/icon-customer.svg";
// import telegram from "../assets/images/telegram.png";
// import livechat from "../assets/images/livechat.png";
import { RxCross2 } from "react-icons/rx";
import { isEmpty } from "lodash";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import Modal from "react-bootstrap/Modal";

const Footer = () => {
  const location = useLocation();
  const { user, showSidebar, active, setFooterLink } = useContext(AuthContext);
  const navigate = useNavigate();
  const [casinoModel, setCasinoModel] = useState(false);
  const [startX, setStartX] = useState(null);
  const [startY, setStartY] = useState(null);
  const [showSupport, setShowSupport] = useState(true);

  const [icon, setIcon] = useState({});
  const handleTouchStart = (event) => {
    const touch = event.touches[0];
    setStartX(touch.clientX);
    setStartY(touch.clientY);
  };

  const getData = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { data } = await apiGet(apiPath?.getIcon, {
      website: "1xbat.bet",
    });
    if (data?.success) {
      setIcon(data?.results);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const handleTouchEnd = (event) => {
    const touch = event.changedTouches[0];
    const endX = touch.clientX;
    const endY = touch.clientY;
    const distance = Math.sqrt((endX - startX) ** 2 + (endY - startY) ** 2);
    if (distance < 5) {
      setCasinoModel(true);
    }
  };
  const [displayPopUp, setDisplayPopUp] = useState(true);

  // when pop-up is closed this function triggers
  const closePopUp = () => {
    // setting key "seenPopUp" with value true into localStorage
    localStorage.setItem("seenPopUp", true);
    // setting state to false to not display pop-up
    setDisplayPopUp(false);
  };

  // the useEffect to trigger on first render and check if in the localStorage we already have data about user seen and closed the pop-up
  useEffect(() => {
    // getting value of "seenPopUp" key from localStorage
    let returningUser = localStorage.getItem("seenPopUp");
    // if it's not there, for a new user, it will be null
    // if it's there it will be boolean true
    // setting the opposite to state, false for returning user, true for a new user
    setDisplayPopUp(!returningUser);
  }, []);
  return (
    <>
      <div className="footer">
        {location?.pathname == "/" && !showSidebar && active == "sports" && (
          <>
            {/* <div className="betbtn1">
              {icon?.whatsappContent &&
                icon?.whatsappContent !== "" &&
                showSupport && (
                  <>
                    <button
                      className="bg-transparent border-0 p-0 close-b"
                      onClick={() => setShowSupport(false)}
                    >
                      <RxCross2 />
                    </button>
                    <div
                      onClick={() => {
                        window.open(
                          "https://wa.me/" + icon?.whatsappContent,
                          "_self"
                        );
                      }}
                    >
                      <img
                        src={
                          icon?.whatsappIcon
                            ? process.env.REACT_APP_API_BASE_URL +
                              icon?.whatsappIcon
                            : whatsapp
                        }
                        alt=""
                      />
                    </div>
                  </>
                )}

              {icon?.telegramContent && icon?.telegramContent !== "" && (
              <div
                onClick={() => {
                  
                  window.open(icon?.telegramContent, "_self");
                }}>
                <img
                  src={icon?.telegramIcon?process.env.REACT_APP_API_BASE_URL + icon?.telegramIcon:telegram}
                  alt=""
                />
              </div>
            )}{" "}
            {icon?.livechatContent && icon?.livechatContent !== "" && location?.pathname == "/" && (
              <div
                onClick={() => {
                  window.open(icon?.livechatContent, "_self");
                }}
              >
                <img
                  src={icon?.livechatIcon?process.env.REACT_APP_API_BASE_URL + icon?.livechatIcon:livechat}
                  alt=""
                />
              </div>
            )}

               {location?.pathname == "/" && (
              <noscript>
                <a
                  href="https://www.livechat.com/chat-with/17022978/"
                  rel="nofollow"
                >
                  Chat with us
                </a>
                , powered by{" "}
                <a
                  href="https://www.livechat.com/?welcome"
                  rel="noopener nofollow"
                  target="_blank"
                >
                  LiveChat
                </a>
              </noscript>
            )}
            </div> */}
            <div className="betbtn2">
              {!isEmpty(user) && (
                <div
                  onClick={() => {
                    window.location.href = "https://wa.me/+971544724056";
                  }}
                  className="livechat-bg blinkPulse"
                >
                  <TfiHeadphoneAlt style={{ color: `#fff` }} />
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {displayPopUp && (
        <Modal centered show={true} onHide={closePopUp} >
          <Modal.Header
            closeButton
            className="mobile-singup-bonus-header"
          ></Modal.Header>
          <Modal.Body className="mobile-singup-bonus">
            <img src="../assets/images/mobi-signup-bonus.png"></img>
            <div className="pop-title ">
            <h3>শুধু মাত্র কোম্পানি এফিলেট ইউজাররা গ্রহণযোগ্য।</h3>
          </div>
          <ul className="popul">
            <li>
              পুরো BBBL and BPL লীগ জুড়ে যে সমস্ত ইউজার এক লাখ টাকা ডিপোজিট (৫ লাখ
              টার্নওভার) করবে, কেবল মাত্র এই সমস্ত ইউজার লটারির জন্য সুযোগ পাবে।
            </li>
            <li>
              এই সমস্ত ইউজার দের নিয়ে আমরা একটি লটারি করবো এবং এদের মধ্যে 1st
              2nd এবং 3rd নির্বাচন করা হবে।
            </li>
            <li>1st পুরস্কার: একটি R15 Version 4 বাইক (এক জনকে)</li>
            <li>2nd পুরস্কার: একটি Royal Enfield Hunter 350 (এক জনকে)</li>
            <li>3rd পুরস্কার: একটি iPhone 16 Pro Max (এক জনকে)</li>
          </ul>
          </Modal.Body>
          
          {/* <Modal.Footer>
            
          </Modal.Footer> */}
        </Modal>
      )}
    </>
  );
};

export default Footer;
